import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, HostBinding, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

class TuiIslandComponent {
    constructor() {
        this.size = 'm';
        this.textAlign = 'left';
        this.hoverable = false;
        this.transparent = false;
    }
    get sizeS() {
        return this.size === 's';
    }
    get sizeM() {
        return this.size === 'm';
    }
    get sizeL() {
        return this.size === 'l';
    }
    get textAlignLeft() {
        return this.textAlign === 'left';
    }
    get textAlignCenter() {
        return this.textAlign === 'center';
    }
    get textAlignRight() {
        return this.textAlign === 'right';
    }
}
TuiIslandComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiIslandComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
TuiIslandComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: TuiIslandComponent, selector: "tui-island, a[tuiIsland]", inputs: { size: "size", textAlign: "textAlign", hoverable: "hoverable", transparent: "transparent" }, host: { properties: { "class.tui-island_hoverable": "this.hoverable", "class.tui-island_transparent": "this.transparent", "class.tui-island_size_s": "this.sizeS", "class.tui-island_size_m": "this.sizeM", "class.tui-island_size_l": "this.sizeL", "class.tui-island_text-align_left": "this.textAlignLeft", "class.tui-island_text-align_center": "this.textAlignCenter", "class.tui-island_text-align_right": "this.textAlignRight" }, classAttribute: "tui-island" }, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [":host{display:block}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiIslandComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'tui-island, a[tuiIsland]',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    templateUrl: './island.template.html',
                    styleUrls: ['./island.style.less'],
                    host: {
                        class: 'tui-island',
                    },
                }]
        }], propDecorators: { size: [{
                type: Input
            }], textAlign: [{
                type: Input
            }], hoverable: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.tui-island_hoverable']
            }], transparent: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.tui-island_transparent']
            }], sizeS: [{
                type: HostBinding,
                args: ['class.tui-island_size_s']
            }], sizeM: [{
                type: HostBinding,
                args: ['class.tui-island_size_m']
            }], sizeL: [{
                type: HostBinding,
                args: ['class.tui-island_size_l']
            }], textAlignLeft: [{
                type: HostBinding,
                args: ['class.tui-island_text-align_left']
            }], textAlignCenter: [{
                type: HostBinding,
                args: ['class.tui-island_text-align_center']
            }], textAlignRight: [{
                type: HostBinding,
                args: ['class.tui-island_text-align_right']
            }] } });

class TuiIslandModule {
}
TuiIslandModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiIslandModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
TuiIslandModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiIslandModule, declarations: [TuiIslandComponent], imports: [CommonModule], exports: [TuiIslandComponent] });
TuiIslandModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiIslandModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: TuiIslandModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [TuiIslandComponent],
                    exports: [TuiIslandComponent],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TuiIslandComponent, TuiIslandModule };
